import { Col, Row, Typography, Button, Modal } from "antd";
import { DeleteOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import bgImg from "../../assets/bg_img.jpg";
import sample1 from "../../assets/sample1.png";
import sample2 from "../../assets/sample2.png";
import shirtImg from "../../assets/menShirt.jpg";
import Config from "../../config/Config";
import success from "../../assets/successGif.gif";
import { useAllProduct } from "../../components/api-context/commonApiContext";

const { Title, Text } = Typography;

const CartSample = () => {
  const {
    merchantInfo,
    moneyLoadStatus,
    setMoneyLoadStatus,
    setIntentLink,
    isLoading,
    setIsLoading,
  } = useAllProduct();

  const [merchantId_d, setMerchantId_d] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("data");
    if (encoded) {
      try {
        const decoded = atob(encoded);
        const [urlPart, salt] = decoded.split("|");
        if (salt !== process.env.REACT_APP_REDIRECT_SALT) {
          throw new Error("Invalid salt — possible tampering.");
        }
        const decodedParams = new URLSearchParams(urlPart.split("?")[1]);
        const newStatus = decodedParams.get("status");
        if (newStatus) setStatus(newStatus);
        console.log("Decoded params:", Object.fromEntries(decodedParams));
      } catch (e) {
        console.error("Error decoding Base64:", e);
      }
    }
  }, []);

  // useEffect(() => {
  //   if (!merchantInfo?.merchant_id) return;

  //   const fetchUserStatus = async () => {
  //     try {
  //       const response = await fetch(
  //         `${Config.node_api_endpoint}/get-user-status`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             "X-API-Key": process.env.REACT_APP_API_KEY,
  //           },
  //           body: JSON.stringify({ payment_id: merchantInfo.payment_id }),
  //         }
  //       );
  //       const result = await response.json();
  //       if (result.success) {
  //         setMoneyLoadStatus(result.data.status);
  //       } else {
  //         console.warn("⚠️ Failed to fetch user:", result.message);
  //       }
  //     } catch (err) {
  //       console.error("Error fetching user status:", err);
  //     }
  //   };

  //   fetchUserStatus();
  // }, [merchantInfo]);

  const registerMerchantKey = async () => {
    try {
      const res = await fetch(
        `${Config.node_api_endpoint}/generate-merchant-key`
      );
      const data = await res.json();

      if (!data.success) {
        console.error("Failed to register merchant:", data);
        alert("Unable to create merchant key.");
        return null;
      }

      localStorage.setItem("merchantToken", data.checkout.token);
      setMerchantId_d(data.distributor.merchant_id);

      console.log("Merchant Key Set:", data);
      return {
        token: data.checkout.token,
        distributorId: data.distributor.merchant_id,
      };
    } catch (error) {
      console.error("Merchant registration failed:", error);
      alert("Failed to register merchant.");
      return null;
    }
  };

  const generateKhazanaLink = async () => {
    try {
      let merchantToken = localStorage.getItem("merchantToken");
      let distributorId = merchantId_d;

      if (!merchantToken || !distributorId) {
        console.log("🔄 Registering new merchant key...");
        const merchantData = await registerMerchantKey();
        console.log("merchantData-->", merchantData);
        
        if (!merchantData) return; // stop if registration failed
        merchantToken = merchantData.token;
        distributorId = merchantData.distributorId;
      }

      const payload = {
        payment_id: `PAY${Date.now()}`,
        amount: 1.0,
        redirect_url: Config.redirect_url,
        merchant_id_d: distributorId,
      };

      console.log("Sending Payment Link Payload:", payload);

      const res = await fetch(
        `${Config.node_api_endpoint}/generate-payment-link`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${merchantToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      console.log("Khazana response:", data);

      if (!data.success) {
        return alert(data.message || "Error generating payment link");
      }

      if (data.redirect_url) {
        window.location.href = data.redirect_url;
      }
    } catch (error) {
      console.error("Payment link error:", error);
      alert("Something went wrong generating payment link.");
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        width: "100vw",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
          borderRadius: 10,
          padding: "20px",
          color: "#000",
        }}
      >
        <Title level={4} style={{ marginBottom: 20 }}>
          Cart Summary
        </Title>

        <Row gutter={12}>
          <Col span={8}>
            <img
              src={shirtImg}
              alt="Shirt"
              style={{
                width: "100%",
                borderRadius: 8,
                objectFit: "cover",
              }}
            />
          </Col>
          <Col span={16}>
            <Text strong style={{ display: "block" }}>
              Paisley Flora Shirt
            </Text>
            <Text style={{ color: "#7D7D7D", fontSize: 13 }}>Size: L</Text>
            <div style={{ marginTop: 5 }}>
              <Text strong>₹854 </Text>
              <Text delete type="secondary" style={{ fontSize: 12 }}>
                ₹1899
              </Text>
            </div>

            <div
              style={{
                marginTop: 8,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Button size="small" shape="circle" icon={<MinusOutlined />} />
              <Text>1</Text>
              <Button size="small" shape="circle" icon={<PlusOutlined />} />
              <DeleteOutlined
                style={{ marginLeft: "auto", color: "#F44336" }}
              />
            </div>
          </Col>
        </Row>

        <div style={{ marginTop: 25 }}>
          <Text strong>Offer For You</Text>
          <Row gutter={10} style={{ marginTop: 10 }}>
            <Col span={12}>
              <img
                src={sample1}
                alt="Offer 1"
                style={{
                  width: "95%",
                  height: 170,
                  borderRadius: 10,
                }}
              />
            </Col>
            <Col span={12}>
              <img
                src={sample2}
                alt="Offer 2"
                style={{
                  width: "95%",
                  height: 170,
                  borderRadius: 10,
                }}
              />
            </Col>
          </Row>
        </div>

        <Row justify="space-between" style={{ marginTop: 25, marginBottom: 5 }}>
          <Text strong>SUBTOTAL:</Text>
          <Text strong>₹799.00</Text>
        </Row>

        <Text
          type="secondary"
          style={{ fontSize: 13, textDecoration: "underline" }}
        >
          Having a Coupon code?
        </Text>

        <Row
          gutter={10}
          style={{ marginTop: 20, width: "100%", textAlign: "center" }}
        >
          <Col span={12}>
            <Button
              style={{
                width: "100%",
                borderRadius: 6,
                backgroundColor: "rgb(235,237,240)",
                height: 45,
              }}
            >
              VIEW CART
            </Button>
          </Col>
          {moneyLoadStatus !== "completed" && (
            <Col span={12}>
              <Button
                type="primary"
                style={{
                  width: "100%",
                  borderRadius: 6,
                  height: 45,
                  background: "rgb(35,36,40)",
                }}
                onClick={() => generateKhazanaLink()}
              >
                Pay with Khazana
              </Button>
            </Col>
          )}
          <Modal
            open={status === "completed"}
            footer={null}
            closable
            centered
            width={350}
            // ✅ allow Modal to close normally with the × icon
            onCancel={() => {
              localStorage.clear();
              localStorage.removeItem(merchantInfo);
              setStatus("");
              setMoneyLoadStatus("");
            }}
            bodyStyle={{
              textAlign: "center",
              padding: "30px 20px",
              borderRadius: "12px",
            }}
          >
            <img
              src={success}
              alt="Success"
              width="180"
              style={{ marginBottom: 10 }}
            />
            <p
              style={{
                color: "#2348AB",
                fontWeight: 600,
                fontSize: 18,
                marginTop: 10,
              }}
            >
              Order placed successfully.
            </p>
          </Modal>
        </Row>
      </div>
    </div>
  );
};

export default CartSample;
